import { render, staticRenderFns } from "./ResponsibleUserDeadline.vue?vue&type=template&id=58c646a5&"
import script from "./ResponsibleUserDeadline.vue?vue&type=script&lang=js&"
export * from "./ResponsibleUserDeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports